<template>
  <v-container class="margen_paginas pt-7" fluid>

    <TablaDatosAPI
      :titulo="$t ('APIs de cargadores')"
      icono="mdi-ev-station"
      tabla="apicar"
      :campos="['id_apicar-', 'des', 'id_empcar', 'ultpetexi']"
      busqueda-rapida
      :titulo-crud="$t ('API de cargadores')"
      :permitir-anadir="permisoEscritura"
      :permitir-modificar="permisoEscritura"
      :permitir-eliminar="permisoEscritura"
    />

  </v-container>
</template>

<script>
import TablaDatosAPI from "@/components/TablaDatosAPI.vue";

export default {
  components: { TablaDatosAPI },
  computed: {
    permisoEscritura() {
      return this.$store.operador.atributosRol.includes ("gesapicar");
    }
  },
};
</script>

<style>
</style>